<template>
  <span class="merge-ph-wrap">
    <el-button :type="buttonType" :size="buttonSize" :plain="plain" @click="open">
      {{ displayButtonText }}
    </el-button>
    <form-dialog
      :title="$t('mergeDialog.dialogTitle')"
      :visible.sync="visible"
      width="720px"
      @open="onDialogOpen"
    >
      <p class="merge-ph-note">
        {{ $t('mergeDialog.note') }}
      </p>
      <el-table v-loading="loading" :data="rows" border size="small" max-height="420">
        <el-table-column prop="example" :label="$t('mergeDialog.colWrite')" min-width="200" />
        <el-table-column :label="$t('mergeDialog.colMerge')" min-width="220">
          <template slot-scope="s">{{ mergePlaceholderDescription(s.row) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visible = false">{{ $t('mergeDialog.gotIt') }}</el-button>
      </span>
    </form-dialog>
  </span>
</template>

<script>
import { getMergePlaceholders } from '@/api/contractTemplate'
import FormDialog from '@/components/FormDialog.vue'

export default {
  name: 'ContractMergePlaceholderDialog',
  components: { FormDialog },
  props: {
    buttonText: { type: String, default: '' },
    buttonType: { type: String, default: 'text' },
    buttonSize: { type: String, default: 'small' },
    plain: { type: Boolean, default: false }
  },
  data() {
    return {
      visible: false,
      loading: false,
      rows: [],
      loaded: false
    }
  },
  computed: {
    displayButtonText() {
      return this.buttonText || this.$t('mergeDialog.title')
    }
  },
  methods: {
    mergePlaceholderDescription(row) {
      if (!row || !row.key) return ''
      const path = `mergeDialog.placeholders.${row.key}`
      const localized = this.$t(path)
      return localized !== path ? localized : (row.description || '')
    },
    open() {
      this.visible = true
    },
    async onDialogOpen() {
      if (this.loaded) return
      this.loading = true
      try {
        const r = await getMergePlaceholders()
        const d = r.data !== undefined ? r.data : r
        this.rows = Array.isArray(d) ? d : []
        this.loaded = true
      } catch (e) {
        this.rows = []
        this.$message.error((e && e.message) || this.$t('common.loadFailed'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.merge-ph-wrap {
  display: inline-block;
  vertical-align: middle;
}

.merge-ph-note {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.65;
  color: var(--dark-text-sub, #8b95a1);
}
</style>
